import styled from "styled-components";

import { CategoryChipItem } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { toggleBranchName } from "app/services/dev-toggle/devToggle";

const BranchNameContainer = styled.div`
    position: fixed;
    top: 10px;
    right: 40px;
    z-index: 99999;
`;

export const BranchNameComponent = () => {
    return (
        <BranchNameContainer>
            <CategoryChipItem
                text={`working against: ${swSettings.version?.split(".")[1]}`}
                onCloseItem={() => toggleBranchName()}
            />
        </BranchNameContainer>
    );
};
